const zhCN = {
  // Navigation
  nav: {
    home: '首页',
    features: '功能特点',
    scenarios: '应用场景',
    integration: '接入指南',
    docs: '文档',
    faq: '常见问题',
    contact: '联系方式'
  },

  // Hero Section
  hero: {
    badge: '🚀 新一代数字货币支付',
    title: {
      line1: '构建',
      line2: '安全稳定',
      line3: '的数字支付'
    },
    subtitle: '支持多种主流稳定币和区块链网络，为您的业务提供快速、安全、低成本的数字货币支付解决方案',
    cta: {
      primary: '立即接入',
      secondary: '查看文档',
      demo: '查看Demo'
    }
  },

  // Stats Section
  stats: {
    title: '平台数据概览',
    subtitle: '为全球企业提供可靠的数字货币支付基础设施',
    volumeValue: '500+',
    volumeUnit: '万美元',
    volume: '累计交易额',
    successValue: '99.8%',
    success: '交易成功率',
    networksValue: '15+',
    networksUnit: '条',
    networks: '支持网络',
    merchantsValue: '100+',
    merchantsUnit: '家',
    merchants: '合作商户',
    description: '数据实时更新，反映平台真实业务表现'
  },

  // Features Section
  features: {
    title: '核心能力',
    subtitle: '为企业提供全方位的数字货币支付基础设施',
    items: {
      multiCurrency: {
        title: '多币种支持',
        description: '支持USDT、USDC、DAI等主流稳定币，满足不同业务需求'
      },
      multiChain: {
        title: '多链覆盖',
        description: '覆盖Ethereum、BSC、Polygon、Arbitrum、Base等12+主流区块链网络'
      },
      quickIntegration: {
        title: '快速接入',
        description: '提供完整的API文档和SDK，支持多种编程语言，30分钟完成集成'
      },
      security: {
        title: '签名校验',
        description: 'MD5签名验证，HTTPS加密传输，多重安全保障防止篡改和重放攻击'
      },
      realtime: {
        title: '实时状态',
        description: '实时订单状态推送，支持webhook回调，确保交易状态及时同步'
      },
      support: {
        title: '7x24支持',
        description: '专业技术团队7x24小时在线支持，快速响应技术问题和故障处理'
      }
    }
  },

  // Scenarios Section
  scenarios: {
    title: '应用场景',
    subtitle: '覆盖多个行业的数字货币支付需求',
    tabs: {
      ecommerce: '跨境电商',
      saas: 'SaaS订阅',
      gaming: '链游资产',
      otc: 'OTC做市'
    },
    content: {
      ecommerce: {
        title: '跨境电商收款',
        description: '解决跨境电商平台的数字货币收款需求',
        points: [
          '支持全球用户使用稳定币支付',
          '避免传统银行转账的高额手续费',
          '实现7x24小时即时到账',
          '支持多种主流稳定币选择'
        ]
      },
      saas: {
        title: 'SaaS订阅服务',
        description: '为SaaS产品提供灵活的数字货币订阅支付',
        points: [
          '支持月付、年付等多种订阅模式',
          '自动化的订阅续费管理',
          '降低支付失败率和拒付风险',
          '覆盖全球用户的支付需求'
        ]
      },
      gaming: {
        title: '数字资产与游戏',
        description: '为区块链游戏和数字资产交易提供支付基础设施',
        points: [
          '支持游戏内资产购买和交易',
          'NFT交易市场支付集成',
          '玩家充值和提现功能',
          '多链游戏资产互通支持'
        ]
      },
      otc: {
        title: 'OTC与做市业务',
        description: '为OTC平台和做市商提供专业的支付解决方案',
        points: [
          '大额交易的安全保障',
          '多签名钱包集成支持',
          '实时汇率和滑点控制',
          '合规性报告和交易记录'
        ]
      }
    }
  },

  // Integration Section
  integration: {
    title: '接入流程',
    subtitle: '四步完成 CoolPay 集成，开始接收数字货币支付',
    steps: {
      0: {
        number: '01',
        title: '注册账号',
        description: '创建 CoolPay 账户，获取商户号和应用凭证'
      },
      1: {
        number: '02',
        title: '配置密钥',
        description: '生成 API 密钥对，配置签名验证参数'
      },
      2: {
        number: '03',
        title: '接入API',
        description: '调用支付网关接口，集成到现有系统'
      },
      3: {
        number: '04',
        title: '开始收款',
        description: '启动数字货币支付服务，处理用户订单'
      }
    },
    cta: '查看文档',
    ready: '准备开始集成？',
    readyDesc: '查看完整的技术文档和API指南'
  },

  // Security Section
  security: {
    title: '安全与合规',
    left: {
      title: '安全措施',
      items: {
        0: {
          title: 'HTTPS 加密传输',
          description: '所有数据传输采用SSL/TLS加密，确保通信安全'
        },
        1: {
          title: 'MD5 签名验证',
          description: '请求和回调均需签名验证，防止数据篡改'
        },
        2: {
          title: '密钥安全存储',
          description: '采用多重加密存储，定期轮换密钥'
        },
        3: {
          title: '实时监控',
          description: '24小时系统监控，异常交易实时告警'
        }
      }
    },
    right: {
      title: '合规认证',
      description: '严格遵守国际安全标准和合规要求，确保您的业务合规运营',
      iso: '安全认证',
      soc: '审计报告',
      privacy: '隐私政策',
      terms: '服务条款'
    }
  },

  // FAQ Section
  faq: {
    title: '常见问题',
    subtitle: '快速获取常见问题的解答',
    items: {
      0: {
        question: '接入 CoolPay 需要多长时间？',
        answer: '通常情况下，技术团队可以在1-2个工作日内完成基础集成。包括测试和上线，整个流程大约需要3-5个工作日。'
      },
      1: {
        question: '支持哪些数字货币和区块链网络？',
        answer: '目前支持 USDT、USDC 等主流稳定币，覆盖 Ethereum、BSC、Polygon、Arbitrum、Base 等15+条主流区块链网络。'
      },
      2: {
        question: '手续费如何收取？',
        answer: '我们采用阶梯式费率结构，根据月交易量提供不同的费率档位。具体费率请联系商务团队获取详细报价。'
      },
      3: {
        question: '是否提供测试环境？',
        answer: '是的，我们提供完整的测试环境（Testnet），您可以在正式上线前充分测试所有功能，确保集成的稳定性。'
      },
      4: {
        question: '如何获得技术支持？',
        answer: '我们提供7x24小时技术支持服务。您可以通过在线客服、技术QQ群或邮件联系我们的技术团队。'
      },
      5: {
        question: '资金安全如何保障？',
        answer: '采用多重签名技术、冷热钱包分离、实时风控监控等多层安全措施，并由专业保险公司承保，确保资金安全。'
      }
    },
    help: {
      title: '还有其他问题？',
      description: '联系我们的技术支持团队获得帮助',
      button: '联系支持'
    }
  },

  // Partners Section
  partners: {
    title: '合作伙伴',
    subtitle: '与全球领先企业共同构建数字货币支付生态',
    categories: ['数字交易所', 'SaaS平台', '区块链游戏', 'OTC机构'],
    stats: {
      clients: '企业客户',
      uptime: '系统可用性',
      support: '技术支持'
    }
  },

  // Contact Section
  contact: {
    title: '联系我们',
    subtitle: '选择最适合的方式与我们取得联系，获得专业支持',
    business: {
      title: '商务合作',
      email: 'business@cool-pay.link',
      description: '商务对接、费率沟通、合作模式洽谈'
    },
    support: {
      title: '技术支持',
      description: '7x24小时在线支持',
      desc: '遇到技术问题或需要帮助',
      button: '联系支持'
    },
    docs: {
      title: '开发文档',
      description: 'API文档与集成指南',
      desc: '完整的开发者资源和文档',
      button: '查看文档'
    },
    resources: {
      title: '开发者资源',
      description: '获取完整的API文档、SDK下载和集成指南，快速开始您的数字货币支付集成之旅',
      api: 'API 文档',
      apiDesc: '完整的REST API参考文档',
      sdk: 'SDK 下载',
      sdkDesc: '多语言SDK和代码示例',
      guide: '集成指南',
      guideDesc: '详细的集成步骤和最佳实践',
      community: '开发者社区',
      communityDesc: '与其他开发者交流经验'
    }
  },

  // Footer
  footer: {
    slogan: '为全球企业提供安全、高效的数字货币支付解决方案',
    product: {
      title: '产品',
      features: '功能特点',
      scenarios: '应用场景',
      pricing: '定价方案',
      security: '安全保障'
    },
    resources: {
      title: '资源',
      api: 'API文档',
      sdk: 'SDK下载',
      guide: '集成指南',
      blog: '技术博客'
    },
    company: {
      title: '公司',
      about: '关于我们',
      privacy: '隐私政策',
      terms: '服务条款',
      contact: '联系我们'
    },
    copyright: '© 2025 cool-pay.link 保留所有权利。',
    poweredBy: 'Website Builder'
  },

  // Language
  language: {
    en: 'English',
    zh: '中文'
  }
};

export default zhCN;
